import { useState, useRef } from 'react';
import Layout from '../Common/Layout';

import { userService } from '../../Services';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAddressCard,
    faCircleNotch
  } from '@fortawesome/free-solid-svg-icons';

const Registration = ({user}) => {
    const [loading, setLoading] = useState(false);
    const [skipped, setSkipped] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const inputRef = useRef();


    const handleFileChange = (e) => {
        setError(false);
        setCsvData({});
        const file = e.target.files[0];

        if (file && file.type === 'text/csv') {
        const reader = new FileReader();

        reader.onload = (event) => {
            const text = event.target.result;
            const rows = text.split('\n').slice(1).filter(item => item !== '').map((row) => row.split(','));
            setCsvData(rows);
        };

        reader.readAsText(file);

        inputRef.current.value = '';
        } else {
            setError('Please upload a valid CSV file');
        }
    };

    const register = async () => {
        setError(false);
        setLoading(true);
        setSkipped(false);

        if (!csvData) {
            setError('Please upload csv file');
            setLoading(false);
            return false;
        }
        
        const data = await userService.bulkRegistration({
            'users': csvData
        });

        if (data.error)
            setError(data.error);
        else if (data.res === 'OK') {
            if (data.skipped.length) {
                setCsvData(csvData.filter((item, index) => data.skipped.includes(index)));
                setSkipped(true);
            } else 
                setCsvData({});
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
            }, 5000);
        }

        setLoading(false);
    }

    return <Layout>
            <div className="top-panel">
                <h1>
                    <FontAwesomeIcon
                        icon={faAddressCard}
                        style={{ fontSize: 25, color: "#59748a" }}
                    />
                    Diver bulk registration
                </h1>
            </div>
            {!csvData.length && <div className="search-patterns">                
                <ol>
                    <li>
                        <strong>Download the CSV Template</strong><br />
                        <strong><a href="/assets/bulk-registration-template.csv" className="blue" download>Click here</a></strong> to download the required CSV file
                    </li>
                    
                    <li>
                        <strong>Fill in All Fields</strong><br />
                        Open the file using Excel, Google Sheets, or any spreadsheet editor.<br />
                        Make sure to <strong>fill in all the fields</strong> for each user.<br />
                        <span><strong>Important:</strong> All fields must be completed — incomplete rows will be skipped during upload.</span>
                    </li>
                    
                    <li>
                        <strong>Save the File</strong><br />
                        Once all data is filled in, save the file in <strong>CSV format</strong> (<code>.csv</code> extension). <br />
                        <strong>Note:</strong> The CSV file must be <strong>comma-separated (,)</strong> — other separators like semicolons (;) are not supported.
                    </li>
                    
                    <li>
                        <strong>Upload the Completed File</strong><br />
                        Return to this page and choose the completed CSV file.<br />
                        Then click the button below to import the users in bulk.
                    </li>
                </ol>
            </div>}
            <div className="upload-file" onClick={() => inputRef.current.click()}>
                <span>
                    Click to upload file
                </span>
                <input type="file" name="input-list" ref={inputRef} onChange={handleFileChange} accept=".csv" />
            </div>
            {(csvData.length ? <><div className="table-wrapper">
                <div className="org-list bulk-reg">
                    <div>
                        <div className="header">
                            <div>Organization</div>
                            <div>Email address</div>
                            <div>First Name</div>
                            <div>Last Name</div>
                            <div>DOB (MM/DD/YYYY)</div>
                            <div>Password</div>
                            <div>Confirm Password</div>
                            <div>Emergency Contact First Name</div>
                            <div>Emergency Contact Last Name</div>
                            <div>Emergency contact relationship</div>
                            <div>Emergency contact phone number</div>
                            <div>Highest recreational diving certification level</div>
                            <div>Certification Agency</div>
                        </div>
                    </div>
                    {csvData.map(item => (
                            <div key={item[1]}>
                                <div>
                                    <div>{item[0]}</div>
                                    <div>{item[1]}</div>
                                    <div>{item[2]}</div>
                                    <div>{item[3]}</div>
                                    <div>{item[4]}</div>
                                    <div>{item[5]}</div>
                                    <div>{item[6]}</div>
                                    <div>{item[7]}</div>
                                    <div>{item[8]}</div>
                                    <div>{item[9]}</div>
                                    <div>{item[10]}</div>
                                    <div>{item[11]}</div>
                                    <div>{item[12]}</div>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
            <button className="blue" onClick={register}>{loading ? <span><FontAwesomeIcon
                    icon={faCircleNotch}
                    style={{ fontSize: 20, color: '#fff'}}
                    spin
                /> </span> : ''}Submit</button>
            </> : <></>)}
            {error ? <div className="alert error">{error}</div> : ''}
            {success ? <div className="alert success">Users have been imported</div> : ''}
            {skipped ? <div className="alert error">Some users don't have the required data. Please review the remaining list and upload a file with the corrected data.</div> : ''}
        </Layout>;
};

export default Registration;